import { withTheme } from "styled-components";
import DefaultTable, {
  ActionButtons,
  Filter,
  Line,
  FormInline,
  FilterCol,
} from "../../ui-library/CustomTable/DefaultTable";
import React, { useState } from "react";
import { Dropdown } from "react-bootstrap";
import AccountStatus from "../AccountStatus/AccountStatus";
import CustomDropdown from "../../ui-library/CustomDropdown/CustomDropdown";
import PrimaryButton from "../../ui-library/Buttons/PrimaryButton/PrimaryButton";
import { UserStatus } from "../AccountStatus/AccountStatus.constants";
import { Sites } from "../../../modules/constants";
import TableDropDown from "../../ui-library/TableDropDown/TableDropDown";
import { useTranslation } from "react-i18next";

const NonParticipantTable = (props) => {
  const {
    getData,
    searchedParams,
    totalitems,
    nonParticipants,
    unlockAccount,
    blockAccount,
    unblockAccount,
    addNonParticipant,
    addNewSite,
    handleResendInvite,
    handleResetPassword,
    sites,
    accessManagement,
    canBlockUser,
    canUnlockUser,
    canEditUser,
    canAddNonParticipant,
    canAddSite,
    canResendInviteNonParticipant,
    canResetPasswordNonParticipant,
    accountUsername,
    loading,
  } = props;

  const { t } = useTranslation();

  const [filterUserStatus, setFilterUserStatus] = useState(null);

  const defaultProps = {
    headers: [
      { label: t("appText.nonParticipants.table.role") },
      { label: t("appText.nonParticipants.table.site") },
      { label: t("appText.nonParticipants.table.name") },
      { label: t("appText.nonParticipants.table.email") },
      { label: t("appText.nonParticipants.table.accountStatus") },
      { label: t("appText.nonParticipants.table.options") },
    ],
    hasSearch: 1,
    haspagesizefilter: 1,
    haspagination: 1,
    searchedParams,
    totalitems,
    loading,
    getData,
  };

  const changeFilterBy = (filter) => {
    const params = {
      ...searchedParams,
      page: 0,
      siteId: filter.id,
    };
    getData(params);
  };

  const changeUserStatus = (userStatus) => {
    const params = {
      ...searchedParams,
      page: 0,
      filter: userStatus.id,
    };
    getData(params, () => {
      setFilterUserStatus(userStatus);
    });
  };

  const getDropDownItems = (user) => {
    const dropDownMenuItems = {
      ACCESS_MANAGEMENT: {
        text: "Access Management",
        callBack: (user) => accessManagement(user),
        id: 1,
        isDisabled: false,
        isVisible: canEditUser,
      },
      RESEND_INVITE: {
        text: t("appText.management.resendInvite"),
        callBack: (user) => handleResendInvite(user),
        id: 4,
        isDisabled: accountUsername === user.userName,
        isVisible:
          canResendInviteNonParticipant &&
          user.status === UserStatus.INVITED.id,
      },
      RESET_PASSWORD: {
        id: 5,
        text: t("appText.management.resetPassword"),
        isVisible: canResetPasswordNonParticipant,
        isDisabled:
          accountUsername === user.userName ||
          user.status !== UserStatus.ACTIVE.id,
        callBack: (user) => handleResetPassword(user),
      },
      UNLOCK_ACCOUNT: {
        text: "Unlock Account",
        callBack: (user) => unlockAccount(user),
        id: 2,
        isDisabled: user.status !== UserStatus.LOCKED.id,
        isVisible: canUnlockUser,
      },
      UNBLOCK_USER: {
        text: "Unblock User",
        callBack: (user) => unblockAccount(user),
        id: 3,
        isVisible: canBlockUser && user.status === UserStatus.BLOCKED.id,
      },
      BLOCK_USER: {
        text: "Block User",
        callBack: (user) => blockAccount(user),
        id: 4,
        isVisible:
          canBlockUser &&
          (user.status === UserStatus.ACTIVE.id ||
            user.status === UserStatus.INVITED.id),
      },
    };

    return Object.values(dropDownMenuItems);
  };

  return (
    <DefaultTable {...defaultProps} data-testid="non-participants-table">
      <Filter>
        <FormInline gap="12px">
          <FilterCol>
            <span>{t("appText.nonParticipants.table.site")}</span>
            <CustomDropdown
              limitheight={true}
              defaultValue={Sites.ALL.value}
              value={
                sites.find((site) => site.id === searchedParams.siteId)?.value
              }
              options={[Sites.ALL, ...sites]}
              onChange={(e) => changeFilterBy(e)}
            />
          </FilterCol>
          <FilterCol>
            <span>{t("appText.nonParticipants.table.status")}</span>
            <CustomDropdown
              defaultValue={UserStatus.ALL.value}
              value={filterUserStatus?.value}
              options={Object.values(UserStatus)}
              onChange={(e) => changeUserStatus(e)}
            />
          </FilterCol>
        </FormInline>
      </Filter>

      <ActionButtons>
        {canAddSite && (
          <PrimaryButton
            data-testid="add-site-btn"
            size="sm"
            className="me-2"
            onClick={addNewSite}
          >
            {t("appText.nonParticipants.table.addSite")}
          </PrimaryButton>
        )}

        {canAddNonParticipant && (
          <PrimaryButton
            data-testid="add-non-participant-btn"
            size="sm"
            onClick={addNonParticipant}
          >
            {t("appText.nonParticipants.table.addNonParticipant")}
          </PrimaryButton>
        )}
      </ActionButtons>

      {nonParticipants?.map((user, index) => (
        <Line key={index}>
          <span>{user.role}</span>
          <span>{user.site}</span>
          <span>{user.name}</span>
          <span>{user.userName}</span>
          <AccountStatus>{user.status}</AccountStatus>
          {accountUsername !== user.userName && (
            <TableDropDown>
              {getDropDownItems(user)
                .filter((dropDownItem) => dropDownItem.isVisible)
                .map((item, index) => (
                  <Dropdown.Item
                    key={index}
                    bsPrefix="dropdown-item"
                    disabled={item.isDisabled}
                    onClick={() => item.callBack(user)}
                  >
                    {item.text}
                  </Dropdown.Item>
                ))}
            </TableDropDown>
          )}
        </Line>
      ))}
    </DefaultTable>
  );
};

export default withTheme(NonParticipantTable);
